import React from 'react';
import Todo from "./Todo.jsx";

const App = () =>{
  return(
    <Todo />
  )
}

export default App;